import React from 'react';
import './companybanner.css';
import Grid from '@material-ui/core/Grid';

const ComapnyBanner = () => {
  return <Grid item xs={ false } sm={ 4 } md={ 6 } className='image' data-test="image-container" />
};

export default ComapnyBanner;